module.exports = __webpack_public_path__ + "static/media/building9.f5e689c3.svg";